import { Fragment, useContext, useEffect, useRef, useState } from "react"
import { changeMonth, fetchEvent } from "../../../actions/calendar"
import { CalendarContext } from "../../../contexts/CalendarProvider"
import { useAuth } from "../../../hooks/useAuth"
import { useSyncModal } from "../../../hooks/useSyncModal"
import { useAsyncModal } from "../../../hooks/useAsyncModal"
import { getCurrentMonth, getCurrentYear, getShortDate } from "../../../utils/calendar"
import { InsideContainer } from "../../containers/InsideContainer"
import { Header } from "../../extras/Header"
import { Loading } from "../../static/Loading"
import { EmptyMessage } from "../../static/Messages"
import { Calendar } from "../../views/Calendar"
import { EventHeader } from "../../views/Event"
import { CreateEvent, CalendarEventDetail } from "../../views/CalendarEvent"


const getMonthDate = (when) => {
    const d = new Date(when)
    return `${d.getDate()}/${(d.getMonth() + 1).toString().padStart(2, '0')}`
}

const EventRow = ({ elem, onClick }) => (
    <div className="om-event uk-grid-small uk-padding-small" uk-grid="" style={{marginTop: '0', marginBottom: '0', cursor: 'pointer'}} onClick={onClick}>
        <div className="om-event-date uk-width-1-5@l uk-width-1-5@m uk-width-1-2">
            <h1 className="om-event-highlight">{getMonthDate(elem.when)}</h1>
        </div>
        <div className="om-event-title uk-width-1-5@l uk-width-1-5@m uk-width-1-2">
            <h4>{elem.type.toUpperCase()}</h4>
            <ul><li>⏰{getShortDate(elem.when)} CEST</li></ul>
        </div>
        <div className="om-event-desc uk-width-expand">
            <p className="om-event-element">{elem.desc || elem.description || ''}</p>
            <ul><li>📍{elem.loc || elem.location || ''}</li></ul>
        </div>
    </div>
)

const MonthNavigation = ({ month, onChangeMonth }) => {
    const handlePrev = () => onChangeMonth(month === 0 ? 11 : month - 1)
    const handleNext = () => onChangeMonth(month === 11 ? 0 : month + 1)

    return(
        <Fragment>
            <div className="hide-s" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', marginBottom: '15px'}}>
                <button className="uk-button uk-button-default uk-button-small" onClick={handlePrev} aria-label="Mes anterior">
                    <i className="fas fa-chevron-left"></i>
                </button>
                <h3 className="uk-text-bold uk-margin-remove"><i className="fas fa-info-circle"></i> Próximos Eventos en {getCurrentMonth(month)}</h3>
                <button className="uk-button uk-button-default uk-button-small" onClick={handleNext} aria-label="Mes siguiente">
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
            <div className="hide-l hide-m" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '10px'}}>
                <button className="uk-button uk-button-default uk-button-small" onClick={handlePrev} aria-label="Mes anterior">
                    <i className="fas fa-chevron-left"></i>
                </button>
                <h3 className="uk-text-bold uk-text-center uk-margin-remove"><i className="fas fa-info-circle"></i> Mes Actual: {getCurrentMonth(month)}</h3>
                <button className="uk-button uk-button-default uk-button-small" onClick={handleNext} aria-label="Mes siguiente">
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
        </Fragment>
    )
}

export const CalendarView = () => {
    const [calendar, dispatch] = useContext(CalendarContext)
    const [user] = useAuth()
    const [loading, setLoading] = useState(false)
    const skipNextUpdate = useRef(false)

    const [open] = useSyncModal()
    const [,setDetailId] = useAsyncModal('event', fetchEvent, CalendarEventDetail, EventHeader)

    const handleAddEvent = () => open(CreateEvent.Header, CreateEvent.Body)
    const handleDetail = (uuid) => setDetailId(uuid)

    const handleChangeMonth = (month) => {
        setLoading(true)
        skipNextUpdate.current = true
        dispatch(changeMonth(month))
    }

    useEffect(() => {
        // Al cambiar de mes, calendar.events se actualiza dos veces:
        // 1ª: SET_MONTH limpia events a [] (inmediato, en el mismo render)
        // 2ª: FETCH trae los eventos del nuevo mes (async, tras la petición)
        // skipNextUpdate salta la 1ª actualización para que loading se mantenga
        // hasta que lleguen los datos reales.
        if(skipNextUpdate.current) {
            skipNextUpdate.current = false
            return
        }
        if(loading) setLoading(false)
    // eslint-disable-next-line
    }, [calendar.events])

    return(
        <InsideContainer reducerContext={[false, calendar, dispatch, user]}>
            <div className="uk-width-2-3@m om-padding-remove@s">
                <Header onClick={handleAddEvent} buttonIcon={"fas fa-calendar-plus"} buttonText={"Crear Evento"}>
                    <i className="far fa-1x fa-calendar-times"></i> Calendario
                </Header>
                <MonthNavigation month={calendar.month} onChangeMonth={handleChangeMonth}/>
                <div className="uk-text-center" id="list">
                    {calendar.error ? <EmptyMessage message={calendar.error}/> :
                    loading ? <Loading large={false}/> :
                    !calendar.events || calendar.events.length === 0 ?
                        <EmptyMessage message={'No se han encontrado eventos'}/> :
                        <div className={'uk-grid uk-grid-small uk-child-width-1-1'} uk-grid="" style={{rowGap: '15px'}}>
                            {calendar.events.map((event, i) => <EventRow key={i} elem={event} onClick={() => handleDetail(event.uuid)}/>)}
                        </div>
                    }
                </div>
            </div>
            <div className="uk-width-1-3@m uk-text-center hide-s">
                <Calendar/>
                <p className="uk-text-justify uk-margin-right">Para obtener información sobre el planning de los días señalados, haz click sobre el día en el calendario.</p>
            </div>
        </InsideContainer>
    )
}